// MiniDashboardTraffic.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faList, faFileInvoice, faListOl, faSortNumericDown, faListNumeric, faSailboat, faTruckLoading, faTruckFront } from '@fortawesome/free-solid-svg-icons';

const MiniDashboardTrafficDetail = ({ uniqueDocumentsCount, lineNumbersCount, uniqueFractionsCount, uniqueBillOfLadingCount }) => {
  return (
    <div className="bg-white shadow rounded-lg p-3 w-full mb-4">
      <div className="grid grid-cols-4 divide-x divide-gray-200 text-center">
        <div className="flex flex-col items-center justify-center py-1">
          <FontAwesomeIcon icon={faFileInvoice} className="text-blue-600 text-2xl mb-1" />
          <p className="text-sm text-gray-600">Unique Documents</p>
          <p className="text-lg font-semibold text-gray-800">{uniqueDocumentsCount}</p>
        </div>
        <div className="flex flex-col items-center justify-center py-1">
          <FontAwesomeIcon icon={faListOl} className="text-blue-600 text-2xl mb-1" />
          <p className="text-sm text-gray-600">Line Numbers</p>
          <p className="text-lg font-semibold text-gray-800">{lineNumbersCount}</p>
        </div>
        <div className="flex flex-col items-center justify-center py-1">
          <FontAwesomeIcon icon={faSortNumericDown} className="text-blue-600 text-2xl mb-1" />
          <p className="text-sm text-gray-600">Fractions</p>
          <p className="text-lg font-semibold text-gray-800">{uniqueFractionsCount}</p>
        </div>
        <div className="flex flex-col items-center justify-center py-1">
          <FontAwesomeIcon icon={faTruckFront} className="text-blue-600 text-2xl mb-1" />
          <p className="text-sm text-gray-600">Unique BOL Documents</p>
          <p className="text-lg font-semibold text-gray-800">{uniqueBillOfLadingCount}</p>
        </div>
      </div>
    </div>
  );
};

export default MiniDashboardTrafficDetail;
